/* eslint-disable no-case-declarations */
import { INPUT_TYPE } from 'components/common/Input/types';
import { usStatesSelectOptions } from 'constants/usStates';
import { get } from 'lodash';
import { INewInitalFieldsProps } from 'routes/Profile/components/ProfileContent/WithAddableInputFormTemplate/types';
import { CompanyRoleEnum, IUser, RoleEnum } from 'types/user';
import { generateContactsInputFieldsProps, generateOtherEmailsInputFieldsProps } from 'utils';
import * as Yup from 'yup';

import Availability from './Availability';
import BondAndInsurance from './BondAndInsurance';
import Company from './Company';
import DocumentShippingAddress from './DocumentShippingAddress';
import GeneralInformation from './GeneralInformation';
import NotaryCommission from './NotaryCommission';
import PaymentAddress from './PaymentAddress';
import { IUserSteps } from './types';

export const getWizardFormData = (tab: string, userInfo: IUser) => {
  switch (tab) {
    case 'generalInformation':
      const otherEmailsInputProps = userInfo ? generateOtherEmailsInputFieldsProps(userInfo.otherEmails) : {};
      const contactsInputProps = userInfo ? generateContactsInputFieldsProps(userInfo.contacts) : {};

      const otherEmailsInputFields = get(otherEmailsInputProps, 'inputFieldProps', {});
      const otherEmailsSchema = get(otherEmailsInputProps, 'validationSchema', {});

      const contactsInputFields = get(contactsInputProps, 'inputFieldProps', {});
      const contactsSchema = get(contactsInputProps, 'validationSchema', {});

      const generalInformationValidationSchema = {
        ...otherEmailsSchema,
        ...contactsSchema,
        firstName: Yup.string().required('Required'),
        lastName: Yup.string().required('Required'),
      };

      const inputFields: INewInitalFieldsProps[] = [
        {
          sectionTitle: 'Name',
          labelProps: ['First Name', 'Last Name'],
          sizes: [12, 12],
          inputProps: [
            {
              name: 'firstName',
              sideFields: [
                {
                  name: 'lastName',
                },
              ],
            },
          ],
        },
        {
          ...otherEmailsInputFields,
          sectionTitle: 'Emails',
          sizes: [12, 12],
          draggable: false,
        },
        {
          ...contactsInputFields,
          sectionTitle: 'Contacts',
          sizes: [6, 6, 12],
          draggable: false,
        },
        {
          sectionTitle: 'Address',
          inputProps: [
            {
              label: 'Address Line 1',
              name: 'address1',
              addressSuggestion: true,
              addressSuggestionSubFields: {
                address1: 'address1',
                city: 'city',
                zip: 'zip',
                state: 'state',
              },
            },
            { label: 'Address Line 2', name: 'address2' },
            { label: 'City', name: 'city' },
            {
              label: 'Zip code',
              name: 'zip',
              sideFields: [
                {
                  size: 12,
                  label: 'State',
                  name: 'state',
                  type: INPUT_TYPE.SELECT,
                  inputOptions: usStatesSelectOptions,
                },
              ],
            },
          ],
        },
      ];

      return {
        inputFieldProps: inputFields,
        validationSchema: generalInformationValidationSchema,
      };

    case 'shipping':
      return {
        inputFieldProps: [],
        validationSchema: {},
      };
    default:
      return {
        inputFieldProps: [],
        validationSchema: {},
      };
  }
};

export const getSteps: (userRole: RoleEnum, companyRole?: CompanyRoleEnum) => IUserSteps[] = (
  userRole,
  companyRole,
) => {
  let userTabs: IUserSteps[] = [];

  switch (userRole) {
    case RoleEnum.NOTARY:
      userTabs = [
        { titleId: 'shipping', component: DocumentShippingAddress },
        { titleId: 'payment', component: PaymentAddress },
        { titleId: 'availability', component: Availability },
        { titleId: 'notaryCommissions', component: NotaryCommission },
        { titleId: 'bondAndInsurance', component: BondAndInsurance },
      ];
      break;
    case RoleEnum.CLIENT:
      if (companyRole === CompanyRoleEnum.ADMIN) userTabs = [{ titleId: 'company', component: Company }];
      break;
    default:
      break;
  }

  return [{ titleId: 'generalInformation', component: GeneralInformation }, ...userTabs];
};
